import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Helpers } from '../helpers';
import { ScriptLoaderService } from '../_services/script-loader.service';

declare let mApp: any;
declare let mUtil: any;
declare let mLayout: any;
@Component({
  selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainComponent implements OnInit {
  constructor(private _script: ScriptLoaderService, private _router: Router) {}
  ngOnInit() {
    this._script
      .loadScripts(
        'body',
        ['assets/vendors/base/vendors.bundle.js', 'assets/demo/demo9/base/scripts.bundle.js'],
        true
      )
      .then(result => {
        Helpers.setLoading(false);
        // optional js to be loaded once
        // TODO: Code Review - Why do we need this?
        this._script.loadScripts(
          'head',
          ['assets/vendors/custom/fullcalendar/fullcalendar.bundle.js'],
          true
        );
      });
    this._router.events.subscribe(route => {
      if (route instanceof NavigationStart) {
        // TODO: Code Review - Why do we need following two pieces of code?
        try {
          // (<any>mLayout).closeAsideMenuOffcanvas();
          // (<any>mLayout).closeHorMenuOffcanvas();
          (<any>mApp).scrollTop();
          Helpers.setLoading(true);
          // hide visible popover
          (<any>$('[data-toggle="m-popover"]')).popover('hide');
        } catch (exception) {
          console.log(exception);
          console.log('routing error');
        }
      }
      if (route instanceof NavigationEnd) {
        // init required js
        (<any>mApp).init();
        (<any>mUtil).init();
        Helpers.setLoading(false);
        // content m-wrapper animation
        let animation = 'm-animate-fade-in-up';
        $('.m-wrapper')
          .one(
            'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
            function(e) {
              $('.m-wrapper').removeClass(animation);
            }
          )
          .removeClass(animation)
          .addClass(animation);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/portalV2/main.component.ts